<header mat-dialog-header>
  <h3 mat-dialog-title>{{ 'APP.ACTIONS.FILE_LIBRARY' | translate }}</h3>
  <div class="wk-segmented-control" data-items="2" aria-labelledby="sc-label-0">
    <div class="wk-segmented-control-body">
      <label
        class="wk-button wk-button-small wk-button-ghost wk-segmented-control-item wk-field-choice-label"
      >
        <input
          class="wk-segmented-control-input"
          type="radio"
          [checked]="tabName === 'versions'"
          (change)="onTabChange('versions')"
        />
        <span class="wk-segmented-control-text"
          >{{ 'APP.ACTIONS.DIALOG_VERSIONS' | translate }}</span
        >
      </label>
      <label
        class="wk-button wk-button-small wk-button-ghost wk-segmented-control-item wk-field-choice-label"
      >
        <input
          class="wk-segmented-control-input"
          type="radio"
          [checked]="tabName === 'documents'"
          (change)="onTabChange('documents')"
        />
        <span class="wk-segmented-control-text"
          >{{ 'APP.ACTIONS.DIALOG_DOCUMENTS' | translate }}</span
        >
      </label>
    </div>
  </div>

  <button mat-icon-button class="close-icon" (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>
</header>

<section mat-dialog-content>
  <wk-compare-versions
    (versionsSelected)="onVersionsSelected($event)"
    *ngIf="tabName === 'versions'"
  ></wk-compare-versions>

  <wk-compare-documents
    *ngIf="tabName === 'documents'"
    [entryId]="nodeId"
    (documentsSelected)="onVersionsSelected($event)"
  >
  </wk-compare-documents>
</section>

<div mat-dialog-actions class="compare-and-merge-dialog-actions">
  <button
    type="button"
    class="wk-button wk-button-text cancel"
    (click)="cancel()"
    (keyup.enter)="cancel()"
  >
    {{ 'APP.ACTIONS.CANCEL' | translate }}
  </button>
  <button
    type="button"
    class="wk-button wk-button-ghost compare-and-merge"
    [disabled]="!selectedVersions"
    (click)="merge()"
    (keyup.enter)="merge()"
  >
    {{ 'APP.ACTIONS.COMPARE_AND_MERGE_BUTTON' | translate }}
  </button>
  <button
    type="button"
    class="wk-button compare"
    [disabled]="!selectedVersions"
    (click)="compare()"
    (keyup.enter)="compare()"
  >
    {{ 'APP.ACTIONS.COMPARE_BUTTON' | translate }}
  </button>
</div>
